import React from 'react';
import { RefreshCw } from 'lucide-react';
import { regenerateExamples } from '../aiModelForm';
import { btnSecondary, Field, inputClass } from '../aiModelUi';
import { StepProps } from './stepTypes';

const ExamplesStep: React.FC<StepProps> = ({ form, isLight, errors, patch }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <p className={`text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
          Samples are used by Test and as the default payload hint for workflows.
        </p>
        <button
          type="button"
          onClick={() => patch(regenerateExamples(form))}
          className={btnSecondary(isLight)}
        >
          <RefreshCw size={12} /> Regenerate from contracts
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Field label="Sample request" error={errors.sampleRequest} isLight={isLight}>
          <textarea
            value={form.sampleRequest}
            onChange={(e) => patch({ sampleRequest: e.target.value })}
            rows={14}
            className={`${inputClass(isLight, Boolean(errors.sampleRequest))} font-mono text-[11px] leading-relaxed`}
          />
        </Field>
        <Field label="Sample response" error={errors.sampleResponse} isLight={isLight}>
          <textarea
            value={form.sampleResponse}
            onChange={(e) => patch({ sampleResponse: e.target.value })}
            rows={14}
            className={`${inputClass(isLight, Boolean(errors.sampleResponse))} font-mono text-[11px] leading-relaxed`}
          />
        </Field>
      </div>
    </div>
  );
};

export default ExamplesStep;
